import { Component, Input, OnInit } from "@angular/core";
import { DataService_MultiStationViewVisitors } from "../shared/data.service";
import { DialogService } from "primeng/dynamicdialog";
import { MsAddAliasComponent } from "./ms-add-alias/ms-add-alias.component";
import { VisitorAliasRequest } from "../shared/VisitorAliasRequest";
import { ConfirmationService } from "primeng/api";

@Component({
	selector: "caass-ms-visitor-aliases",
	templateUrl: "./ms-visitor-aliases.component.html",
	styleUrls: ["./ms-visitor-aliases.component.css"],
})
export class MsVisitorAliasesComponent implements OnInit {
	constructor(
		private visitorService: DataService_MultiStationViewVisitors,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadData();
	}

	ngOnChanges() {
		this.loadData();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SelectedVisitor: any;

	pagerows: number = 10;
	pagefirst: number = 0;
	LoadingAlias: boolean = false;
	Processing: boolean = false;
	errorMessage: string = "";

	//Main
	SelectedPersons: any = [];
	lstPerson: any = [];

	//Filter lists
	lstState: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "LicenseNbr", header: "License" },
		{ field: "State", header: "State" },
		{ field: "Email", header: "Email" },
		{ field: "PhoneNbr", header: "Phone" },
	];

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadData() {
		this.ClearData();

		if (this.SelectedVisitor == undefined || this.SelectedVisitor.PersonID == undefined) {
			return;
		}

		this.LoadingAlias = true;

		var result = this.visitorService.VisitorAliasSelectList(this.SelectedVisitor.PersonID);
		result.subscribe(
			(response) => {
				this.lstPerson = response;

				//Load Data Filter Lists
				this.lstState = Array.from(new Set(this.lstPerson.map((item: any) => item.State)));

				this.LoadingAlias = false;
			},
			(error) => {
				this.LoadingAlias = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.errorMessage = "";

		if (this.SelectedVisitor == undefined) {
			this.errorMessage = "Select a Visitor";
			return;
		}

		this.loadData();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		if (this.SelectedVisitor == undefined) {
			this.errorMessage = "Select a Visitor";
			return;
		}

		var popup_Width = (window.innerWidth - 80).toString() + "px";

		var ref = this.dialogService.open(MsAddAliasComponent, {
			header: "Add Aliases",
			width: popup_Width,
			data: {
				//INSERT Custom Data here
				PersonID: this.SelectedVisitor.PersonID,
				FirstName: this.SelectedVisitor.FirstName,
				LastName: this.SelectedVisitor.LastName,
				LicenseNbr: this.SelectedVisitor.LicenseNbr,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadData();
			}
		});
	}

	onDelete() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedVisitor == undefined) {
			this.errorMessage = "Select a Visitor";
			return;
		}

		if (this.SelectedPersons.length == 0) {
			this.errorMessage = "Select aliases to remove";
			return;
		}

		this.Processing = true;

		//Call SP
		var lstPIDs: number[] = [];
		for (var z = 0; z < this.SelectedPersons.length; z++) {
			var next = this.SelectedPersons[z];

			lstPIDs = [...lstPIDs, next.PersonID];
		}

		var parms: VisitorAliasRequest = {
			PersonID: this.SelectedVisitor.PersonID,
			lstAlias: lstPIDs,
		};

		var result = this.visitorService.VisitorAliasDelete(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.loadData();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "aliasmain",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not remove the aliases: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);

		this.Processing = false;
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onRowSelect(val) {
		this.errorMessage = "";
		// this.SelectedPerson = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";
		// this.SelectedPerson = null;
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	ClearData() {
		this.errorMessage = "";
		this.SelectedPersons = [];
		this.lstPerson = [];
	}

	IsLoading() {
		return this.LoadingAlias == true || this.Processing == true;
	}

	////////////////////////////////////////////
}
